<template>
  <div class="page-wrapper">
    <div class="content container-fluid">
      <!-- Page Header -->
      <div class="page-header">
        <div class="row align-items-center">
          <div class="col">
            <h3 class="page-title mb-1">Danh mục Thu Chi</h3>
            <ul class="breadcrumb mb-0">
              <li class="breadcrumb-item"><a href="/">Dashboard</a></li>
              <li class="breadcrumb-item active">Thu Chi - Danh mục</li>
            </ul>
          </div>
          <div class="col-auto mt-3 mt-md-0">
            <button class="btn btn-white mr-2" @click="reloadDanhMuc">
              <i class="fa fa-refresh mr-1" /> Tải lại
            </button>
            <button class="btn btn-primary" @click="openCreateForm">
              <i class="fa fa-plus mr-1" /> Thêm danh mục
            </button>
          </div>
        </div>
      </div>
      <!-- /Page Header -->

      <!-- Tabs loại -->
      <div class="mb-3">
        <div class="btn-group" role="group" aria-label="Loai thu chi">
          <button
            class="btn"
            :class="activeLoai === 'CHI' ? 'btn-danger' : 'btn-outline-danger'"
            @click="setLoai('CHI')"
          >
            <i class="fa fa-arrow-down mr-1" /> Danh mục Chi
          </button>
          <button
            class="btn"
            :class="activeLoai === 'THU' ? 'btn-success' : 'btn-outline-success'"
            @click="setLoai('THU')"
          >
            <i class="fa fa-arrow-up mr-1" /> Danh mục Thu
          </button>
        </div>
      </div>

      <!-- Bộ lọc -->
      <div class="card mb-3">
        <div class="card-body">
          <div class="row align-items-end">
            <div class="col-12 col-md-4 mb-2">
              <label class="form-label small mb-1">Tìm kiếm</label>
              <input
                v-model="filterKeyword"
                type="text"
                class="form-control"
                placeholder="Tên, mô tả..."
              />
            </div>
            <div class="col-6 col-md-3 mb-2">
              <label class="form-label small mb-1">Trạng thái</label>
              <select v-model="filterTrangThai" class="form-control">
                <option value="ALL">Tất cả</option>
                <option value="ACTIVE">Đang hoạt động</option>
                <option value="INACTIVE">Ngưng sử dụng</option>
              </select>
            </div>
            <div class="col-6 col-md-3 mb-2">
              <label class="form-label small mb-1">Sắp xếp</label>
              <select v-model="sortMode" class="form-control">
                <option value="NAME_ASC">Tên A → Z</option>
                <option value="NAME_DESC">Tên Z → A</option>
                <option value="ACTIVE_FIRST">Đang hoạt động trước</option>
              </select>
            </div>
            <div class="col-12 col-md-2 mb-2 text-md-right">
              <button class="btn btn-white btn-sm mt-2 mt-md-0" @click="resetFilter">
                <i class="fa fa-eraser mr-1" /> Xóa lọc
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Summary -->
      <div class="row mb-2">
        <div class="col-12 col-md-4 mb-2">
          <div class="card mini-stat bg-light h-100">
            <div class="card-body d-flex flex-column">
              <div class="d-flex justify-content-between align-items-center mb-1">
                <span class="text-muted small">
                  Tổng danh mục {{ activeLoai === 'CHI' ? 'Chi' : 'Thu' }}
                </span>
                <i
                  :class="['fa', activeLoai === 'CHI' ? 'fa-arrow-down text-danger' : 'fa-arrow-up text-success']"
                />
              </div>
              <h4 class="mb-1">{{ danhMucList.length }}</h4>
              <small class="text-muted mt-auto">
                Hiển thị {{ filteredDanhMuc.length }} danh mục sau khi lọc
              </small>
            </div>
          </div>
        </div>
        <div class="col-6 col-md-4 mb-2">
          <div class="card mini-stat bg-soft-success h-100">
            <div class="card-body d-flex flex-column">
              <div class="d-flex justify-content-between align-items-center mb-1">
                <span class="text-muted small">Đang hoạt động</span>
                <i class="fa fa-check-circle text-success" />
              </div>
              <h4 class="mb-1">{{ countActive }}</h4>
              <small class="text-muted mt-auto">
                Có thể gán cho nhân viên sử dụng
              </small>
            </div>
          </div>
        </div>
        <div class="col-6 col-md-4 mb-2">
          <div class="card mini-stat bg-soft-secondary h-100">
            <div class="card-body d-flex flex-column">
              <div class="d-flex justify-content-between align-items-center mb-1">
                <span class="text-muted small">Ngưng sử dụng</span>
                <i class="fa fa-ban text-secondary" />
              </div>
              <h4 class="mb-1">{{ countInactive }}</h4>
              <small class="text-muted mt-auto">
                Chỉ còn trong lịch sử, không cho chọn mới
              </small>
            </div>
          </div>
        </div>
      </div>

      <!-- Danh sách danh mục -->
      <div class="card">
        <div class="card-body">
          <div v-if="loading.list" class="mb-2">
            <span class="spinner-border spinner-border-sm mr-2" role="status"></span>
            Đang tải danh mục...
          </div>

          <div v-if="!filteredDanhMuc.length && !loading.list" class="text-center text-muted small py-3">
            Chưa có danh mục nào. Hãy bấm
            <strong>Thêm danh mục</strong>
            ở góc trên bên phải.
          </div>

          <div class="row">
            <div
              v-for="dm in filteredDanhMuc"
              :key="dm.id || dm.idDanhMuc"
              class="col-6 col-md-4 col-lg-3 mb-3"
            >
              <div class="card h-100 danh-muc-card">
                <div class="card-body d-flex flex-column">
                  <div class="d-flex align-items-center mb-2">
                    <div class="dm-avatar mr-2">
                      <img
                        v-if="iconOf(dm)"
                        :src="iconOf(dm)"
                        alt="icon"
                        class="dm-avatar-img"
                      />
                      <div v-else class="dm-avatar-placeholder">
                        <i
                          :class="[
                            'fa',
                            activeLoai === 'CHI' ? 'fa-arrow-down' : 'fa-arrow-up',
                          ]"
                        ></i>
                      </div>
                    </div>
                    <div class="flex-grow-1">
                      <div class="dm-title text-truncate" :title="dm.tenDanhMuc">
                        {{ dm.tenDanhMuc }}
                      </div>
                      <div class="small text-muted text-truncate" :title="dm.moTa || dm.ghiChu">
                        {{ dm.moTa || dm.ghiChu || 'Không có mô tả' }}
                      </div>
                    </div>
                  </div>

                  <div class="mb-2">
                    <span
                      class="badge badge-pill mr-1"
                      :class="isActive(dm) ? 'badge-success' : 'badge-secondary'"
                    >
                      {{ isActive(dm) ? 'Đang hoạt động' : 'Ngưng sử dụng' }}
                    </span>
                    <span class="badge badge-light">
                      {{ activeLoai === 'CHI' ? 'CHI' : 'THU' }}
                    </span>
                  </div>

                  <div class="mt-auto d-flex justify-content-between align-items-center">
                    <button
                      class="btn btn-sm btn-white"
                      @click="openEditForm(dm)"
                    >
                      <i class="fa fa-pencil mr-1" /> Sửa
                    </button>
                    <button
                      class="btn btn-sm btn-outline-danger"
                      @click="onDelete(dm)"
                    >
                      <i class="fa fa-trash-o" />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <p class="small text-muted mt-2 mb-0">
            Danh mục được dùng để phân loại các phiếu
            <strong>{{ activeLoai === 'CHI' ? 'Chi' : 'Thu' }}</strong>
            trong luồng Thu Chi, đồng thời hiển thị icon ở giao diện của nhân viên.
          </p>
        </div>
      </div>

      <!-- Backdrop modal -->
      <div v-if="showFormModal" class="modal-backdrop fade show"></div>

      <!-- Modal tạo / sửa danh mục -->
      <div
        v-if="showFormModal"
        :class="['modal', 'fade', { show: showFormModal }]"
        tabindex="-1"
        role="dialog"
        style="display: block;"
      >
        <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <div>
                <h5 class="modal-title mb-0">
                  {{ formMode === 'CREATE' ? 'Thêm danh mục' : 'Cập nhật danh mục' }}
                </h5>
                <small class="text-muted">
                  Loại: {{ activeLoai === 'CHI' ? 'Chi (NV bỏ tiền)' : 'Thu (Tạm ứng/Thu hộ)' }}
                </small>
              </div>
              <button type="button" class="close" @click="closeForm">
                <span>&times;</span>
              </button>
            </div>

            <div class="modal-body">
              <div class="row">
                <!-- Thông tin chính -->
                <div class="col-12 col-md-7 mb-3">
                  <div class="form-group">
                    <label class="small">Tên danh mục <span class="text-danger">*</span></label>
                    <input
                      v-model="form.tenDanhMuc"
                      type="text"
                      class="form-control"
                      placeholder="Ví dụ: Đổ xăng, Tạm ứng đi đường..."
                    />
                  </div>

                  <div class="form-group">
                    <label class="small">Mô tả</label>
                    <textarea
                      v-model="form.moTa"
                      rows="3"
                      class="form-control"
                      placeholder="Ghi chú thêm về cách dùng danh mục này..."
                    ></textarea>
                  </div>

                  <div class="form-group mb-1">
                    <div class="custom-control custom-switch">
                      <input
                        v-model="form.dangHoatDong"
                        type="checkbox"
                        class="custom-control-input"
                        id="dm-active-switch"
                      />
                      <label class="custom-control-label small" for="dm-active-switch">
                        Đang hoạt động (cho phép nhân viên chọn)
                      </label>
                    </div>
                  </div>
                  <small class="text-muted">
                    Nếu tắt, danh mục vẫn giữ trong lịch sử nhưng không cho tạo phiếu mới với danh mục này.
                  </small>
                </div>

                <!-- Icon / avatar -->
                <div class="col-12 col-md-5 mb-3">
                  <div class="card border h-100">
                    <div class="card-header py-2">
                      <h6 class="mb-0">Icon / Avatar danh mục</h6>
                    </div>
                    <div class="card-body py-2">
                      <div class="d-flex align-items-center mb-2">
                        <div class="dm-avatar mr-2">
                          <img
                            v-if="form.iconUrl"
                            :src="form.iconUrl"
                            alt="icon"
                            class="dm-avatar-img"
                          />
                          <div v-else class="dm-avatar-placeholder big">
                            <i
                              :class="[
                                'fa',
                                activeLoai === 'CHI'
                                  ? 'fa-arrow-down'
                                  : 'fa-arrow-up',
                              ]"
                            ></i>
                          </div>
                        </div>
                        <div class="flex-grow-1">
                          <div class="small text-muted mb-1">
                            Ảnh sẽ hiển thị cho nhân viên khi chọn danh mục.
                          </div>
                          <div v-if="form.iconUrl" class="small text-truncate">
                            {{ form.iconUrl }}
                          </div>
                        </div>
                      </div>

                      <div class="form-group mb-2">
                        <label class="small">Upload icon mới</label>
                        <input
                          type="file"
                          class="form-control-file"
                          accept="image/*"
                          @change="onIconFileChange"
                          :disabled="iconUploading"
                        />
                        <div v-if="iconUploading" class="small text-muted mt-1">
                          <span class="spinner-border spinner-border-sm mr-1"></span>
                          Đang upload icon...
                        </div>
                      </div>

                      <div class="form-group mb-1">
                        <button
                          class="btn btn-sm btn-white mr-1"
                          type="button"
                          @click="toggleIconLibrary"
                        >
                          <i class="fa fa-image mr-1" />
                          Chọn từ thư viện
                        </button>
                        <button
                          v-if="form.iconUrl"
                          class="btn btn-sm btn-outline-secondary"
                          type="button"
                          @click="form.iconUrl = ''"
                        >
                          <i class="fa fa-times mr-1" /> Xóa icon
                        </button>
                      </div>

                      <!-- Icon library -->
                      <div v-if="showIconLib" class="mt-2 icon-lib">
                        <div v-if="iconLibLoading" class="small text-muted">
                          <span class="spinner-border spinner-border-sm mr-1"></span>
                          Đang tải thư viện icon...
                        </div>
                        <div v-else-if="!iconLibrary.length" class="small text-muted">
                          Chưa có icon nào trong thư mục
                          <code>thu-chi-danh-muc</code>.
                        </div>
                        <div v-else class="d-flex flex-wrap">
                          <div
                            v-for="(img, idx) in iconLibrary"
                            :key="idx"
                            class="icon-lib-item"
                            :class="{ active: form.iconUrl === img.url }"
                            @click="form.iconUrl = img.url"
                          >
                            <img
                              :src="img.url"
                              :alt="img.title"
                              class="icon-lib-img"
                            />
                          </div>
                        </div>
                      </div>

                      <small class="text-muted d-block mt-2">
                        Khuyến nghị dùng icon vuông, kích thước khoảng 256×256.
                      </small>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="modal-footer">
              <button class="btn btn-secondary" @click="closeForm">
                Hủy
              </button>
              <button
                class="btn btn-primary"
                :disabled="saving || !form.tenDanhMuc.trim()"
                @click="onSubmitForm"
              >
                <span
                  v-if="saving"
                  class="spinner-border spinner-border-sm mr-1"
                ></span>
                <i v-else class="fa fa-save mr-1"></i>
                {{ formMode === 'CREATE' ? 'Lưu danh mục' : 'Cập nhật' }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {
  ref,
  reactive,
  computed,
  onMounted,
} from "vue";
import api from "@/api/index.js";
import { useToast } from "vue-toastification";

const toast = useToast();

/* ---------------------- State chính ---------------------- */

const activeLoai = ref("CHI"); // CHI / THU
const danhMucList = ref([]);
const loading = reactive({
  list: false,
});

/* Bộ lọc */
const filterKeyword = ref("");
const filterTrangThai = ref("ALL"); // ALL / ACTIVE / INACTIVE
const sortMode = ref("NAME_ASC");

/* Modal form */
const showFormModal = ref(false);
const formMode = ref("CREATE"); // CREATE / EDIT
const form = reactive({
  id: null,
  tenDanhMuc: "",
  moTa: "",
  dangHoatDong: true,
  iconUrl: "",
});
const saving = ref(false);

/* Icon upload & library */
const iconUploading = ref(false);
const showIconLib = ref(false);
const iconLibrary = ref([]);
const iconLibLoading = ref(false);

/* ---------------------- Computed ---------------------- */

const filteredDanhMuc = computed(() => {
  let list = [...danhMucList.value];

  // Lọc theo từ khóa
  const kw = filterKeyword.value.trim().toLowerCase();
  if (kw) {
    list = list.filter((dm) => {
      const name = (dm.tenDanhMuc || "").toLowerCase();
      const moTa = (dm.moTa || dm.ghiChu || "").toLowerCase();
      return name.includes(kw) || moTa.includes(kw);
    });
  }

  // Lọc theo trạng thái
  if (filterTrangThai.value === "ACTIVE") {
    list = list.filter((dm) => isActive(dm));
  } else if (filterTrangThai.value === "INACTIVE") {
    list = list.filter((dm) => !isActive(dm));
  }

  // Sắp xếp
  if (sortMode.value === "NAME_ASC") {
    list.sort((a, b) =>
      (a.tenDanhMuc || "").localeCompare(b.tenDanhMuc || "", "vi")
    );
  } else if (sortMode.value === "NAME_DESC") {
    list.sort((a, b) =>
      (b.tenDanhMuc || "").localeCompare(a.tenDanhMuc || "", "vi")
    );
  } else if (sortMode.value === "ACTIVE_FIRST") {
    list.sort((a, b) => {
      const da = isActive(a) ? 0 : 1;
      const db = isActive(b) ? 0 : 1;
      if (da !== db) return da - db;
      return (a.tenDanhMuc || "").localeCompare(b.tenDanhMuc || "", "vi");
    });
  }

  return list;
});

const countActive = computed(
  () => danhMucList.value.filter((dm) => isActive(dm)).length
);
const countInactive = computed(
  () => danhMucList.value.filter((dm) => !isActive(dm)).length
);

/* ---------------------- Utils ---------------------- */

function isActive(dm) {
  if (dm.dangHoatDong !== undefined && dm.dangHoatDong !== null) {
    return !!dm.dangHoatDong;
  }
  if (dm.trangThai !== undefined && dm.trangThai !== null) {
    // 1 = hoạt động
    return dm.trangThai === 1;
  }
  return true;
}

function iconOf(dm) {
  return dm.iconUrl || dm.icon || dm.avatarUrl || "";
}

function resetForm() {
  form.id = null;
  form.tenDanhMuc = "";
  form.moTa = "";
  form.dangHoatDong = true;
  form.iconUrl = "";
}

function resetFilter() {
  filterKeyword.value = "";
  filterTrangThai.value = "ALL";
  sortMode.value = "NAME_ASC";
}

/* ---------------------- Load dữ liệu ---------------------- */

async function loadDanhMuc() {
  loading.list = true;
  try {
    const res = await api.get("/api/thu-chi/danh-muc", {
      params: { loai: activeLoai.value },
    });
    danhMucList.value = res.data || [];
  } catch (e) {
    console.error(e);
    toast.error("Lỗi khi tải danh mục Thu Chi");
  } finally {
    loading.list = false;
  }
}

async function reloadDanhMuc() {
  await loadDanhMuc();
}

/* ---------------------- Tab & hành động ---------------------- */

function setLoai(loai) {
  if (activeLoai.value === loai) return;
  activeLoai.value = loai;
  showFormModal.value = false;
  resetFilter();
  loadDanhMuc();
}

/* ---------------------- Form modal ---------------------- */

function openCreateForm() {
  formMode.value = "CREATE";
  resetForm();
  showFormModal.value = true;
  showIconLib.value = false;
}

function openEditForm(dm) {
  formMode.value = "EDIT";
  resetForm();
  form.id = dm.id || dm.idDanhMuc || null;
  form.tenDanhMuc = dm.tenDanhMuc || "";
  form.moTa = dm.moTa || dm.ghiChu || "";
  form.dangHoatDong = isActive(dm);
  form.iconUrl = iconOf(dm);
  showFormModal.value = true;
  showIconLib.value = false;
}

function closeForm() {
  if (saving.value) return;
  showFormModal.value = false;
}

/* ---------------------- Upload icon ---------------------- */

function onIconFileChange(e) {
  const file = e.target.files[0];
  if (!file) return;

  const fd = new FormData();
  fd.append("files", file);
  fd.append("folderName", "thu-chi-danh-muc");

  iconUploading.value = true;
  api
    .post("/api/images/upload", fd, {
      headers: { "Content-Type": "multipart/form-data" },
    })
    .then((res) => {
      const arr = res.data || [];
      if (!arr.length) {
        toast.error("Không nhận được URL icon sau khi upload");
        return;
      }
      const first = arr[0];
      const url = first.location || first.url || first.filePath;
      if (!url) {
        toast.error("Dữ liệu icon trả về không hợp lệ");
        return;
      }
      form.iconUrl = url;
      toast.success("Upload icon thành công");
      // Refresh thư viện nếu đang mở
      if (showIconLib.value) {
        loadIconLibrary();
      }
    })
    .catch((err) => {
      console.error(err);
      toast.error("Lỗi khi upload icon");
    })
    .finally(() => {
      iconUploading.value = false;
      e.target.value = "";
    });
}

/* ---------------------- Thư viện icon ---------------------- */

function toggleIconLibrary() {
  showIconLib.value = !showIconLib.value;
  if (showIconLib.value && !iconLibrary.value.length) {
    loadIconLibrary();
  }
}

async function loadIconLibrary() {
  iconLibLoading.value = true;
  try {
    const res = await api.get("/api/images/list/thu-chi-danh-muc");
    const arr = res.data || [];
    iconLibrary.value = arr.map((x) => ({
      url: x.url || x.filePath,
      title: x.title,
      uploadedAt: x.uploadedAt,
    }));
  } catch (e) {
    console.error(e);
    toast.error("Không tải được thư viện icon");
  } finally {
    iconLibLoading.value = false;
  }
}

/* ---------------------- Submit form ---------------------- */

async function onSubmitForm() {
  if (!form.tenDanhMuc.trim()) {
    toast.error("Tên danh mục không được để trống");
    return;
  }

  const payload = {
    tenDanhMuc: form.tenDanhMuc.trim(),
    loai: activeLoai.value,
    moTa: form.moTa?.trim() || null,
    iconUrl: form.iconUrl || null,
    dangHoatDong: form.dangHoatDong,
  };

  saving.value = true;
  try {
    if (formMode.value === "CREATE") {
      await api.post("/api/thu-chi/danh-muc", payload);
      toast.success("Đã tạo danh mục mới");
    } else {
      if (!form.id) {
        toast.error("Không xác định được ID danh mục cần sửa");
        saving.value = false;
        return;
      }
      await api.put(`/api/thu-chi/danh-muc/${form.id}`, payload);
      toast.success("Đã cập nhật danh mục");
    }
    closeForm();
    await loadDanhMuc();
  } catch (e) {
    console.error(e);
    toast.error("Lỗi khi lưu danh mục");
  } finally {
    saving.value = false;
  }
}

/* ---------------------- Xóa mềm ---------------------- */

async function onDelete(dm) {
  const id = dm.id || dm.idDanhMuc;
  if (!id) {
    toast.error("Không xác định được ID danh mục cần xóa");
    return;
  }
  if (
    !window.confirm(
      `Xóa mềm danh mục "${dm.tenDanhMuc}"?\nDanh mục sẽ không còn cho chọn nhưng vẫn giữ lịch sử.`
    )
  ) {
    return;
  }

  try {
    await api.delete(`/api/thu-chi/danh-muc/${id}`);
    toast.success("Đã xóa mềm danh mục");
    await loadDanhMuc();
  } catch (e) {
    console.error(e);
    toast.error("Lỗi khi xóa danh mục");
  }
}

/* ---------------------- Lifecycle ---------------------- */

onMounted(async () => {
  await loadDanhMuc();
});
</script>

<style scoped>
.page-title {
  font-size: 1.25rem;
  font-weight: 600;
}

/* Summary cards */
.mini-stat {
  border-radius: 0.75rem;
  box-shadow: 0 4px 12px rgba(15, 34, 58, 0.08);
}
.bg-soft-success {
  background-color: rgba(40, 167, 69, 0.07);
}
.bg-soft-secondary {
  background-color: rgba(108, 117, 125, 0.07);
}

/* Card danh mục */
.danh-muc-card {
  border-radius: 0.9rem;
  box-shadow: 0 3px 10px rgba(15, 34, 58, 0.08);
}

.dm-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  overflow: hidden;
  flex-shrink: 0;
}
.dm-avatar-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.dm-avatar-placeholder {
  width: 100%;
  height: 100%;
  background: #f1f3f5;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #999;
}
.dm-avatar-placeholder.big {
  width: 56px;
  height: 56px;
  border-radius: 50%;
}
.dm-avatar-placeholder i {
  font-size: 1.1rem;
}

.dm-title {
  font-size: 0.9rem;
  font-weight: 600;
}

/* Modal override để chạy không cần JS Bootstrap */
.modal {
  background: rgba(0, 0, 0, 0.25);
}
.modal-dialog {
  max-width: 900px;
}
.modal-content {
  border-radius: 0.75rem;
}
.modal-header,
.modal-footer {
  padding: 0.75rem 1rem;
}
.modal-body {
  padding: 0.75rem 1rem;
}

/* Icon library */
.icon-lib {
  max-height: 220px;
  overflow-y: auto;
  border-top: 1px dashed #e9ecef;
  padding-top: 6px;
}

.icon-lib-item {
  width: 48px;
  height: 48px;
  border-radius: 0.75rem;
  border: 1px solid #e9ecef;
  margin: 2px;
  overflow: hidden;
  cursor: pointer;
  position: relative;
}
.icon-lib-item.active {
  border-color: #007bff;
  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);
}
.icon-lib-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* Responsive */
@media (max-width: 767.98px) {
  .card-body {
    padding: 0.75rem;
  }
}
</style>
